import React, { Component } from "react";
import Collapse from "reactstrap/lib/Collapse";
import { configuration } from "../../appConfig";
import PageNo from "./PageNo";
import Axios from "axios";
import { connect } from "react-redux";
import ".././newstyle.css";
// import ".././newfooterstyle.css";
import "../../views/Dashboard/qrlist.css";
import "./ReportHeaderFooter.css";

class ReportFooter_New extends Component {
  state = {
    insurenceProviderInfo: [],
    words: {},
    lang: "",
    fallbackInfo: {},
  };

  async componentDidMount() {
    await this.getFallbackDetails();
    await this.getInsuranceName();
    this.getInsurenceClients();
    this.getLang();
    await this._getData();
  }
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang });
      this.setState({ words: res.data });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    let currentLang
    if (this.props.reportType === 'newReportFull' && lang === 'fr') {
      currentLang = 'ch-fr'
    } else {
      currentLang = lang
    }
    return words[word] ? words[word][currentLang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  getFallbackDetails = async () => {
    const url =
      configuration.getFallbackDetails +
      `?partner_id=${localStorage.getItem("partnerId")}`;
    const res = await Axios.get(url);
    let fallback_data = {};
    if (res.data.success !== false) {
      let company_logo =
        configuration.getFallbackLogoPath +
        localStorage.getItem("partnerId") +
        "/" +
        res.data.company_logo;
      fallback_data = {
        Logo: res.data.company_logo
          ? company_logo
          : require("../../assets/img/brand/Adi.png"),
        Email: res.data.company_email || "sales@adi-gmbh.com",
        CompanyName: res.data.company_name || "Auto Damage Inspection GmbH",
        Website: res.data.company_website || "https://adi-gmbh.com",
        Address: res.data.company_address || "Kreuzstr 81, 85716 Unterschleißheim, Germany.",
        PrimaryColor: res.data.primary_color || "#FF0000",
        SecondaryColor: res.data.secondary_color || "#000000",
        PrimaryContact: res.data.contact_number || "08954809487",
        RegisterNo: res.data.company_registration_number || "HRB1234",
      };
    } else {
      fallback_data = {
        Logo: require("../../assets/img/brand/Adi.png"),
        Email: "sales@adi-gmbh.com",
        CompanyName: "Auto Damage Inspection GmbH",
        Website: "https://adi-gmbh.com",
        Address: "Kreuzstr 81, 85716 Unterschleißheim, Germany.",
        PrimaryColor: "#FF0000",
        SecondaryColor: "#000000",
        PrimaryContact: "08954809487",
        RegisterNo: "HRB1234",
      };
    }
    this.setState({ fallbackInfo: fallback_data });
  };

  getInsuranceName = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    if (partnerId) {
      const res = await Axios.get(
        configuration.getCustomerInfo +
        "?partnerId=" +
        partnerId +
        "&vin=" +
        vin
      );
      if (res.data.length) {
        localStorage.setItem("InsurenceName", res.data[0].InsurenceName);
      } else {
        localStorage.setItem("InsurenceName", "");
        // this.setState({ insurenceProviderInfo: this.state.fallbackInfo });
      }
    } else {
      localStorage.setItem("InsurenceName", "");
      // this.setState({ insurenceProviderInfo: this.state.fallbackInfo });
    }
  };

  getInsurenceClients = async () => {
    const partnerId = localStorage.getItem("partnerId");
    let InsurenceName = localStorage.getItem("InsurenceName");
    if (InsurenceName === 'null') {
      InsurenceName = null;
    }
    if (InsurenceName && partnerId) {
      const url = configuration.getInsurenceClients + "?partnerId=" + partnerId;

      Axios.get(url).then((res) => {
        if (res.data) {
          let insurenceProviderInfo;
          res.data.map((data, index) => {
            if (data.Name === InsurenceName) {
              insurenceProviderInfo = data;
            }
          });
          this.setState({ insurenceProviderInfo: insurenceProviderInfo });
        } else {
          this.setState({ insurenceProviderInfo: this.state.fallbackInfo });
        }
      });
    } else {
      this.setState({ insurenceProviderInfo: this.state.fallbackInfo });
    }
  };

  _onImageError = () => {
    let insurenceProviderInfo = this.state.insurenceProviderInfo;
    insurenceProviderInfo.Logo = require("../../assets/img/brand/logo.png");
    this.setState({ insurenceProviderInfo: insurenceProviderInfo });
  };

  _getData = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
        this.setState({ data: r.data.Datetime, jsonData: r.data });
      }
    });
  };

  render() {
    const pdfHeader = localStorage.getItem("pdfHeader");
    const pdfFooter = localStorage.getItem("pdfFooter");
    const partnerId = localStorage.getItem("partnerId");
    const userSession = localStorage.getItem("userSession");
    const selectedFile = localStorage.getItem("selectedFile");
    const data = userSession ? JSON.parse(userSession) : {};
    const { insurenceProviderInfo, fallbackInfo } = this.state;
    const date = new Date();
    let Month = date.getMonth() + 1;

    return (
      <>
        <div className="bottom-footer-wrapper us-report-footer">
          <div className="bottom-new-footer">
            <div className="container-fluid p-0 information-footer-top">
              <div className="new-report-footer-row row new-bottom-footer-details p-0">
                <div className="col-12 information-footer-col p-0">
                  <div className="row p-0 information-footer-row">
                    <div className="col-lg-4 col-md-3 col-sm-3 col-12 p-0 right-border-footer footer-col">
                      <div className="footer-logo">
                        <img width="100%" src={fallbackInfo.Logo} />
                      </div>
                      <div className="footer-website-details">
                        <h4 className="footer-text-small"> {fallbackInfo.Website} </h4>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12 p-0 right-border-footer footerAddressBox footer-col">
                      <div className="footerAddress">
                        <h4 className="footer-address-text"> {fallbackInfo.CompanyName || "Auto Damage Inspection GmbH"} </h4>
                        <h6 className="footer-sub-text"> {fallbackInfo.Address}</h6>
                        <div className="footer-number-website">
                          <span>{insurenceProviderInfo && insurenceProviderInfo.PrimaryContact}</span>
                          <span className="address-line"></span>
                          <span> {fallbackInfo.Email}</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-3 col-sm-3 col-12 p-0 footer-col">
                      <div className="footer-second-logo">
                        {partnerId !== '10-200410' && partnerId !== '21-220221' && <img className="w-100" src={require("../../assets/img/brand/dns-adi.jpg")} />}
                        {(partnerId === '10-200410' || partnerId === '21-220221') && <img className="w-100" src={require("../../assets/img/brand/Report-footer.png")} />}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid copy-right-footer fixed-footer">
              <div className="row footer-first-row">
                <div className="col-12 footer-first-col">
                  <div className="row p-0">
                    <div className="col-8 col-md-8 col-sm-12 col-12  inner-col-footer bottom-footer-first-col">
                      <div className="footer-copyRight-text">
                        <p>Copyright<sup>&copy;</sup> <span>ADI<sup>&reg;</sup></span> <span className="fullYear">{date.getFullYear()}</span>  <span>{this.lang("All rights reserved.")}</span>
                          <label>
                            <span>&nbsp;DnS: </span><span>{localStorage.getItem("partnerId")}, </span>
                          </label>
                          <label>
                            <span>&nbsp;&nbsp;{this.lang("Date")} /</span> <span>{this.lang("Time")}: </span>
                            {this.state.data
                              ? this.state.data.split("_")[2] +
                              "." +
                              this.state.data.split("_")[1] +
                              "." +
                              this.state.data.split("_")[0] +
                              " " + "/" + " " +
                              this.state.data.split("_")[3] +
                              ":" +
                              this.state.data.split("_")[4]
                              : null}
                          </label>
                        </p>
                        <div className="linear-header-white-box-footer"></div>
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-sm-12 col-12 inner-col-footer black-bottom-border bottom-footer-second-col">
                      <div className="footer-black-bottom-line">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
    // }
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(ReportFooter_New);
